import KendoDropDownTree from '../KendoDropDownTree'

let KendoDropDownTreeInstaller = class {
    static install(Vue) {
        Vue.component(KendoDropDownTree.name, KendoDropDownTree)
    }
}

export default KendoDropDownTreeInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoDropDownTreeInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowntree-vue-wrapper/src/kendo-dropdowntree-installer/index.js